module.exports = new __parcel__URL__("battleroyale_kills_button.d777f710.png").toString();